import React, {useState} from 'react';

import {SubEventType} from 'types/App';
import FilePickerDialog from 'components/forms/FilePickerDialog';
import EditTrackForm from './EditTrackForm';
import {TrackPoint} from './CompetitorTrackForm';
import {Button} from '@mui/material';
import CreateDialogBody from 'components/forms/CreateDialogBody';
import {convertGpxToTrackArray} from 'services/gpxUtils';

const ImportTrackFromGPS = (props: ImportTrackFromGPSProps) => {
  const {
    subEvent,
    callback,
    competitor: {color}
  } = props;

  const [track, setTrack] = useState<TrackPoint[]>([]);

  const handleFileChange = (result: string) => {
    setTrack(convertGpxToTrackArray(result));
  };

  return (
    <React.Fragment>
      <FilePickerDialog
        accept=".gpx"
        extension="gpx"
        handleFileChange={handleFileChange}
        primaryButton={
          <Button type="submit" form="create_CompetitorTrack" variant="contained">
            Create
          </Button>
        }
      >
        <CreateDialogBody onSuccess={callback}>
          <EditTrackForm subEvent={subEvent} data={track} color={color} />
        </CreateDialogBody>
      </FilePickerDialog>
    </React.Fragment>
  );
};

export default ImportTrackFromGPS;

type ImportTrackFromGPSProps = {
  subEvent: SubEventType;
  competitor: {
    color: string;
    deviceName: string;
  };
  callback?: () => void;
};
